import { render } from "./NaverRedirectPage.vue?vue&type=template&id=5bff2033"
import script from "./NaverRedirectPage.vue?vue&type=script&lang=js"
export * from "./NaverRedirectPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__